<template>
  <div>
    <table class="table table-bordered table-striped w-100 dataTable dtr-inline">
      <thead>
        <tr>
          <th>Nazwa</th>

          <th>Przypisana jednostka oświatowa</th>

          <th width="9%" />
        </tr>
      </thead>

      <tbody>
        <row
          v-for="(item, index) in $schema.mapping.$items"
          :key="index"
          :item="item.$item"
          @save="saveValue"
          @remove="remove"
        />
      </tbody>
    </table>

    <w-button class="btn-primary mt-4 float-right" text="Dodaj nowe mapowanie" @click="addNew" />
  </div>
</template>

<script>
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/structureNodeMapping.schema';

import Row from './StructureNodeMappingSetting/Row';

// @vuese
// Edycja ustawienia mapowania jednostek oświatowcyh
// @group Setting
export default {
  components: {
    Row
  },
  mixins: [formMixin],
  schema,
  props: {
    // Wartość ustawienia
    value: {
      type: Object,
      required: true
    }
  },

  mounted() {
    this.loadMapping();
  },

  methods: {
    // @vuese
    // Ładowanie mapowania z wartości ustawienia
    loadMapping() {
      this.$schema.mapping.$setData(JSON.parse(this.value.$model));
    },
    // @vuese
    // Dodaje nowe mapowanie
    addNew() {
      this.$schema.mapping.$addRow({ name: '', currentNodeId: null, edit: true });
    },
    // @vuese
    // Zapisuje mapowanie do wartości ustawienia
    saveValue() {
      this.value.$model = JSON.stringify(this.$schema.mapping.$getData());
    },
    // @vuese
    // Usuwa mapowanie
    remove(index) {
      this.$schema.mapping.$removeRow(index);
      this.saveValue();
    }
  }
};
</script>
